import React from "react";

import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { Characteristic } from "store/types";

import { Form } from "./Form";

interface Props {
  onSuccess: (characteristic: Characteristic) => void;
  onCancel: () => void;
}

export const Create: React.FC<Props> = ({ onSuccess, onCancel }) => {
  const { createCharacteristicAction } = useDealActions();

  const { loading, action } = useActionHook(createCharacteristicAction, {
    onSuccess
  });

  return <Form onSubmit={action} isLoading={loading} onCancel={onCancel} />;
};
